import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	improvementTopicChip: {
		backgroundColor: themeColors.colors.system.purple[100],
		color: themeColors.colors.system.purple[700],
		borderRadius: "999px",
		fontSize: "0.75rem",
		fontWeight: 600,
		height: "24px",
		border: "none"
	},
	flatAccordion: {
		boxShadow: "none",
		border: "none",
		backgroundColor: "transparent",
		margin: 0,
		"&:before": {
			display: "none"
		}
	},
	flatAccordionSummary: {
		padding: 0,
		minHeight: "auto"
	},
	flatAccordionDetails: {
		padding: 0
	},
	recommendationBox: {
		padding: "12px",
		backgroundColor: themeColors.colors.system.purple[50],
		borderRadius: "8px",
		display: "flex",
		flexDirection: "column",
		gap: "8px"
	},
	recommendationLabel: {
		fontSize: "0.7rem",
		fontWeight: 600,
		color: themeColors.colors.system.purple[700],
		textTransform: "uppercase",
		letterSpacing: "0.05em"
	},
	recommendationText: {
		fontSize: "0.875rem",
		color: themeColors.colors.system.gray[700]
	}
}))

export default useStyles
